// Step 1: prices are stored and displayed in INR. Live multi-currency
// conversion is a future module (/currency-exchange), so we never fake rates.

export function formatINR(amount) {
  if (amount == null || isNaN(amount)) return "\u20b90";
  return "\u20b9" + Number(amount).toLocaleString("en-IN");
}

export const CURRENCIES = [
  { code: "INR", symbol: "\u20b9", name: "Indian Rupee" },
  { code: "USD", symbol: "$", name: "US Dollar" },
  { code: "EUR", symbol: "\u20ac", name: "Euro" },
  { code: "GBP", symbol: "\u00a3", name: "British Pound" },
  { code: "AED", symbol: "\u062f.\u0625", name: "UAE Dirham" },
  { code: "AUD", symbol: "A$", name: "Australian Dollar" },
  { code: "CAD", symbol: "C$", name: "Canadian Dollar" },
  { code: "SGD", symbol: "S$", name: "Singapore Dollar" },
  { code: "JPY", symbol: "\u00a5", name: "Japanese Yen" },
  { code: "CHF", symbol: "CHF", name: "Swiss Franc" },
];
